import { useIsMobile } from '@/hooks/use-mobile'
import { CategoriesBaseProps } from './CategoriesBase'
import { CategoriesMobile } from './CategoriesMobile'
import { CategoriesDesktop } from './CategoriesDesktop'

/**
 * Unified Categories component that renders mobile or desktop version
 * Uses useIsMobile hook to conditionally render the appropriate version
 * This approach separates mobile and desktop code completely
 */
export const Categories = (props: CategoriesBaseProps) => {
  const isMobile = useIsMobile()

  // Completely separate mobile and desktop rendering
  // No CSS classes mixing - pure conditional rendering
  if (isMobile) {
    return <CategoriesMobile {...props} />
  }

  return <CategoriesDesktop {...props} />
}

